import axios from 'axios';
import config from 'config.js';

// Constants
const GET_TEMPLATES_REQUEST = 'templates/GET_TEMPLATES_REQUEST';
const GET_TEMPLATES_SUCCESS = 'templates/GET_TEMPLATES_SUCCESS';
const GET_TEMPLATES_FAILURE = 'templates/GET_TEMPLATES_FAILURE';

const GET_TEMPLATE_CATEGORIES_REQUEST = 'templates/GET_TEMPLATE_CATEGORIES_REQUEST';
const GET_TEMPLATE_CATEGORIES_SUCCESS = 'templates/GET_TEMPLATE_CATEGORIES_SUCCESS';
const GET_TEMPLATE_CATEGORIES_FAILURE = 'templates/GET_TEMPLATE_CATEGORIES_FAILURE';

const CREATE_TEMPLATE_CATEGORIES_REQUEST = 'templates/CREATE_TEMPLATE_CATEGORIES_REQUEST';
const CREATE_TEMPLATE_CATEGORIES_SUCCESS = 'templates/CREATE_TEMPLATE_CATEGORIES_SUCCESS';
const CREATE_TEMPLATE_CATEGORIES_FAILURE = 'templates/CREATE_TEMPLATE_CATEGORIES_FAILURE';

const CREATE_TEMPLATE_REQUEST = 'templates/CREATE_TEMPLATE_REQUEST';
const CREATE_TEMPLATE_SUCCESS = 'templates/CREATE_TEMPLATE_SUCCESS';
const CREATE_TEMPLATE_FAILURE = 'templates/CREATE_TEMPLATE_FAILURE';

const REMOVE_TEMPLATE_REQUEST = 'templates/REMOVE_TEMPLATE_REQUEST';
const REMOVE_TEMPLATE_SUCCESS = 'templates/REMOVE_TEMPLATE_SUCCESS';
const REMOVE_TEMPLATE_FAILURE = 'templates/REMOVE_TEMPLATE_FAILURE';

const REMOVE_TEMPLATE_CATEGORY_REQUEST = 'templates/REMOVE_TEMPLATE_CATEGORY_REQUEST';
const REMOVE_TEMPLATE_CATEGORY_SUCCESS = 'templates/REMOVE_TEMPLATE_CATEGORY_SUCCESS';
const REMOVE_TEMPLATE_CATEGORY_FAILURE = 'templates/REMOVE_TEMPLATE_CATEGORY_FAILURE';

const getEndpointStatus = (type) => {
  const types = {
    request: {
      loading: true,
      error: false,
      success: false
    },
    success: {
      loading: false,
      error: false,
      success: true
    },
    failure: {
      loading: false,
      error: true,
      success: false
    },
  };

  return types[type];
};

const endpoitInitialStatus = {
  loading: false,
  error: false,
  success: false
};

// Initiual State
const initialState = {
  templates: null,
  templateCategories: null,

  getTemplates: { ...endpoitInitialStatus },
  getTemplateCategories: { ...endpoitInitialStatus },
  createTemplateCategory: { ...endpoitInitialStatus },
  removeTemplateCategory: { ...endpoitInitialStatus },
  createTemplate: { ...endpoitInitialStatus },
  removeTemplate: { ...endpoitInitialStatus }
};

// Reducer
export default function reducer(state = JSON.parse(JSON.stringify(initialState)), action = {}) {
  // getTemplates
  if (action.type === GET_TEMPLATES_REQUEST) {
    state.getTemplates = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_TEMPLATES_SUCCESS) {
    state.getTemplates = getEndpointStatus('success');
    state.templates = action.payload;

    return { ...state };
  }

  if (action.type === GET_TEMPLATES_FAILURE) {
    state.getTemplates = getEndpointStatus('failure');

    return { ...state };
  }

  // getTemplateCategories
  if (action.type === GET_TEMPLATE_CATEGORIES_REQUEST) {
    state.getTemplateCategories = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === GET_TEMPLATE_CATEGORIES_SUCCESS) {
    state.getTemplateCategories = getEndpointStatus('success');
    state.templateCategories = action.payload;

    return { ...state };
  }

  if (action.type === GET_TEMPLATE_CATEGORIES_FAILURE) {
    state.getTemplateCategories = getEndpointStatus('failure');

    return { ...state };
  }

  // createTemplateCategory
  if (action.type === CREATE_TEMPLATE_CATEGORIES_REQUEST) {
    state.createTemplateCategory = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === CREATE_TEMPLATE_CATEGORIES_SUCCESS) {
    state.createTemplateCategory = getEndpointStatus('success');

    return { ...state };
  }

  if (action.type === CREATE_TEMPLATE_CATEGORIES_FAILURE) {
    state.createTemplateCategory = getEndpointStatus('failure');

    return { ...state };
  }

  // createTemplate
  if (action.type === CREATE_TEMPLATE_REQUEST) {
    state.createTemplate = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === CREATE_TEMPLATE_SUCCESS) {
    state.createTemplate = getEndpointStatus('success');

    return { ...state };
  }

  if (action.type === CREATE_TEMPLATE_FAILURE) {
    state.createTemplate = getEndpointStatus('failure');

    return { ...state };
  }

  // removeTemplate
  if (action.type === REMOVE_TEMPLATE_REQUEST) {
    state.removeTemplate = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === REMOVE_TEMPLATE_SUCCESS) {
    state.removeTemplate = getEndpointStatus('success');

    return { ...state };
  }

  if (action.type === REMOVE_TEMPLATE_FAILURE) {
    state.removeTemplate = getEndpointStatus('failure');

    return { ...state };
  }

   // removeTemplateCategory
   if (action.type === REMOVE_TEMPLATE_CATEGORY_REQUEST) {
    state.removeTemplateCategory = getEndpointStatus('request');

    return { ...state };
  }

  if (action.type === REMOVE_TEMPLATE_CATEGORY_SUCCESS) {
    state.removeTemplateCategory = getEndpointStatus('success');

    return { ...state };
  }

  if (action.type === REMOVE_TEMPLATE_CATEGORY_FAILURE) {
    state.removeTemplateCategory = getEndpointStatus('failure');

    return { ...state };
  }

  return state;
}

// Action Creators
export function getTemplates() {
  const request = () => { return { type: GET_TEMPLATES_REQUEST } };
  const success = (res) => { return { type: GET_TEMPLATES_SUCCESS, payload: res } };
  const failure = () => { return { type: GET_TEMPLATES_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getTemplates();

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function getTemplateCategories() {
  const request = () => { return { type: GET_TEMPLATE_CATEGORIES_REQUEST } };
  const success = (res) => { return { type: GET_TEMPLATE_CATEGORIES_SUCCESS, payload: res } };
  const failure = () => { return { type: GET_TEMPLATE_CATEGORIES_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.getTemplateCategories();

    if (response && response.status === 200) {
      return dispatch(success(response.data));
    } else {
      return dispatch(failure());
    }
  };
}

export function createTemplateCategory(data) {
  const request = () => { return { type: CREATE_TEMPLATE_CATEGORIES_REQUEST } };
  const success = (res) => { return { type: CREATE_TEMPLATE_CATEGORIES_SUCCESS, payload: res } };
  const failure = () => { return { type: CREATE_TEMPLATE_CATEGORIES_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.createTemplateCategory(data);

    if (response) {
      return dispatch(success(response));
    } else {
      return dispatch(failure());
    }
  };
}

export function createTemplate(data) {
  const request = () => { return { type: CREATE_TEMPLATE_REQUEST } };
  const success = (res) => { return { type: CREATE_TEMPLATE_SUCCESS, payload: res } };
  const failure = () => { return { type: CREATE_TEMPLATE_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.createTemplate(data);

    if (response) {
      return dispatch(success(response));
    } else {
      return dispatch(failure());
    }
  };
}

export function removeTemplate(id) {
  const request = () => { return { type: REMOVE_TEMPLATE_REQUEST } };
  const success = () => { return { type: REMOVE_TEMPLATE_SUCCESS } };
  const failure = () => { return { type: REMOVE_TEMPLATE_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.removeTemplate(id);

    if (response) {
      return dispatch(success(response));
    } else {
      return dispatch(failure());
    }
  };
}

export function removeTemplateCategory(id) {
  const request = () => { return { type: REMOVE_TEMPLATE_CATEGORY_REQUEST } };
  const success = () => { return { type: REMOVE_TEMPLATE_CATEGORY_SUCCESS } };
  const failure = () => { return { type: REMOVE_TEMPLATE_CATEGORY_FAILURE } };

  return async (dispatch) => {
    dispatch(request());

    const response = await services.removeTemplateCategory(id);

    if (response) {
      return dispatch(success(response));
    } else {
      return dispatch(failure());
    }
  };
}

const services = {
  getTemplates: async () => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/templates`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  getTemplateCategories: async () => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${config.apiUrl}/api/admin/templateCategories`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response;
    } catch (e) {
      return e.response;
    }
  },
  createTemplateCategory: async (data) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${config.apiUrl}/api/admin/templateCategories`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        },
        data
      });

      return response.data;
    } catch (e) {
      return false;
    }
  },
  createTemplate: async (data) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${config.apiUrl}/api/admin/templates`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        },
        data
      });

      return response.data;
    } catch (e) {
      return false;
    }
  },
  removeTemplate: async (id) => {
    try {
      const response = await axios({
        method: 'DELETE',
        url: `${config.apiUrl}/api/admin/templates/${id}`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response.data;
    } catch (e) {
      return false;
    }
  },
  removeTemplateCategory: async (id) => {
    try {
      const response = await axios({
        method: 'DELETE',
        url: `${config.apiUrl}/api/admin/templateCategories/${id}`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('user_token')}`
        }
      });

      return response.data;
    } catch (e) {
      return false;
    }
  },
};
